import { useState, useEffect } from 'react';
import { fetchAlertsApi } from '../../store/app/apis';
import { getTime } from '../../utils';
import { connect } from 'react-redux';
import './index.css';
import Hamburger from '../../components/HamburgerMenu/HamburgerMenu';
import { useNavigate } from 'react-router-dom';
import { TablePagination } from '@mui/material';
import PhishingIcon from '@mui/icons-material/Phishing';

export function Notifications({ fetchAlertsApi, alerts }) {
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  let navigate = useNavigate();
  const getHookPage = (event) => {
    navigate(`/dashboard/hook`);
  };
  const getServiceDetailPage = (event, id) => {
    event.preventDefault();
    navigate(`/dashboard/details/${id}`);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const styles = {
    '& .MuiTablePagination-toolbar': {
      paddingRight: '20px',
      bottom: '0px',
      right: '0px',
      position: 'fixed',
      width: '100%',
      backgroundColor: '#ebedef',
    },
    '& .MuiIconButton-root': {
      padding: '0px',
      boxShadow: 'none',
    },
  };

  useEffect(() => {
    var payload = {};
    payload['size'] = rowsPerPage;
    payload['page'] = page + 1;
    fetchAlertsApi(payload).then((res) => setCount(res));
  }, [page, rowsPerPage]);
  return (
    <div className={styles.noti}>
      <div>
        <Hamburger></Hamburger>
      </div>
      <div className={styles.notifications}>
        <div className="buttonAndNotification">
          <h1>Notifications</h1>
          <button
            onClick={(event) => {
              getHookPage();
            }}
            style={{ display: 'flex', height: '40px' }}
          >
            <PhishingIcon />
            Hook Settings
          </button>
        </div>
      </div>
      <div className="notification_alerts">
        <table>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', paddingLeft: '40px' }}>Service</th>

              <th>Time</th>
              <th style={{ textAlign: 'left' }}>Alerts</th>
            </tr>
          </thead>
          <tbody>
            {alerts?.map((alert) => (
              <tr>
                <td style={{ paddingLeft: '40px', textAlign: 'left' }}>
                  <a
                    href={`/dashboard/details/${alert?.service}`}
                    onClick={(event) => {
                      getServiceDetailPage(event, alert?.service);
                    }}
                    style={{ textDecoration: 'none' }}
                  >
                    {alert.sname}
                  </a>
                </td>
                <td>{getTime(alert.ct)}</td>
                <td style={{ textAlign: 'left', maxWidth: '40%' }}>{alert.msg || 'No message'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 75, 100, 200, 300, 400, 500]}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        count={count}
        page={page}
        onPageChange={handleChangePage}
        sx={styles}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  alerts: state.app.alerts,
});
const mapDispatchToProps = { fetchAlertsApi };

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
